<template>
  <div class="wrap">
    <img class="img" src="../../assets/images/payok.png" alt="">
    <div class="ok-text">支付成功</div>
    <div class="text">系统将在{{ num }}s后自动跳转到课程页面</div>
    <div class="btn btn1" @click="goKc">前往课程页面</div>
    <div class="btn btn2" @click="goMe">查看我的会员</div>
  </div>
</template>
<script>
import grxx from "../../assets/images/grxx.png";
import woyy from "../../assets/images/woyy.png";
import wdsc from "../../assets/images/wdsc.png";
import next from "../../assets/images/next.png";
import store from "../../store";

import noMemberPng from '../../assets/images/no_member.png';
import {getHttp} from "../../plugin/extendFn/postHttp";

export default {
  data() {
    return {
      num: 6,
      interval: 0
    };
  },
  props: {},
  filters: {},
  methods: {
    goKc() {
      this.$router.replace({
        name: "Video"
      });
    },
    goMe() {
      this.$router.replace({
        name: "Me"
      });
    }
  },
  mounted() {
    window.document.title = '支付成功'
    this.interval = setInterval(() => {
      this.num--;
      if (this.num == 0) {
        clearInterval(this.interval);
        this.goKc();
      }
    }, 1000)
  },

  destroyed() {
    window.document.title = '';
    clearInterval(this.interval);
  }

};
</script>
<style scoped lang="scss">
body, html {
}

.wrap {
  height: 100vh;
  padding: 1rem .95rem;

  display: flex;
  flex-direction: column;
  align-items: center;

  .img {
    width: 1.28rem;
    height: 1.28rem;
  }

  .ok-text {
    margin-top: .18rem;
    font-size: .36rem;
    font-family: SourceHanSansCN;
    font-weight: bold;
    color: #31A141;
  }

  .text {
    margin-top: .5rem;
    font-size: .3rem;
    font-family: SourceHanSansCN;
    font-weight: bold;
    color: #666666;
  }

  .btn1 {
    margin-top: 1rem !important;
    background: #018BE1;
  }

  .btn2 {
    background: #3BBC4D;
  }

  .btn {
    height: .9rem;
    border-radius: .1rem;
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;

    margin-top: .3rem;

    font-size: .34rem;
    font-family: SourceHanSansCN;
    font-weight: bold;
    color: #FFFFFF;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/me/payOk.vue